export const MeteoOptions = Object.freeze({
  Wind: "Wind",
  Currents: "Ocean Currents",
  Waves: "Wave Height"
});

export function windOptionToInt(option) {
  switch (option) {
  case MeteoOptions.Currents:
    return "08dcfce0-e0b3-44bd-8245-cfe7cc25ddbc";
    // return 512
  case MeteoOptions.Wind:
    return "08dcfce1-34c8-48b7-8cc4-3ef7899e26ee";
    // return 1
  case MeteoOptions.Waves:
    return "08dcfce1-02d8-4c70-87fd-63144c349c75";
        // return 16
  }
}
